globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Settings = appCustomerSpace.Controllers.Settings || {};

appCustomerSpace.Controllers.Settings.ReviewsController = (function (superClass) {
  utils.extend(ReviewsController, superClass);

  function ReviewsController() {
    return ReviewsController.__super__.constructor.apply(this, arguments);
  }

  $.extend(ReviewsController.prototype, {
    init: function() {
      this._initEvents();
      return ReviewsController.__super__.init.apply(this, arguments);
    },
    _initEvents: function () {
      $("select.automatic-reply-mode-select").on('change', function() {
        var $replyTemplateElement = $(this).closest('.automatic-reply-setting-row').find('.automatic-reply-setting-reply-template');

        if ($(this).val() == 'template') {
          $replyTemplateElement.show();
          if ($replyTemplateElement.data('reply-template-uniq-key') == "") {
            $replyTemplateElement.find('.select-reply-template-btn').trigger('click');
          }
        } else {
          $replyTemplateElement.hide();
        }
      });
    }
  });

  return ReviewsController;

})(appCustomerSpace.Controllers.Settings.MainController);
